import {PredictService} from '../../../services/predict.service';
import {distanceVisibleInCamera, getCameraBoundingBox, toBBoxString} from '../cesiumTools';
import {LayerDatasource, LayerLoadType, LayerType, MapperViewer} from '../types';

export class ZmTsunamiLayer implements LayerDatasource {
  id = 'zm_tsunami';
  name = 'ZM Tsunami';
  active = true;
  dataSource = new Cesium.GeoJsonDataSource(this.name);
  type = LayerType.DataSource;
  loadType = LayerLoadType.MoveEnd;
  viewer: MapperViewer;

  /* Custom properties */
  color = Cesium.Color.fromCssColorString('#079fba').withAlpha(0.6);
  colorMoyen = Cesium.Color.fromCssColorString('#057A8F').withAlpha(0.6);
  colorFort = Cesium.Color.fromCssColorString('#045767').withAlpha(0.6);

  detailVisible = true;
  previouslyLoadedBbox = null;

  hasDetail = true;

  constructor(
    private predictService: PredictService,
  ) {}

  remove(): void {
    this.viewer.dataSources.remove(this.dataSource);
  }

  initialize(viewer: MapperViewer): void {
    this.viewer = viewer;
    viewer.dataSources.add(this.dataSource);
  }

  setDetailVisible(visible: boolean): void {
    this.detailVisible = visible;
    this.applyStyle();
  }

  loadData(forceReload = false): void {
    if (!this.dataSource) {
      console.error('Viewer not initialized');
      return;
    }

    const distance = distanceVisibleInCamera(this.viewer);

    if (!distance || distance > 41) {
      return;
    }

    const bbox = toBBoxString(getCameraBoundingBox(this.viewer));

    if (this.previouslyLoadedBbox === bbox && !forceReload) {
      return;
    }

    this.predictService.getZmTsunami(bbox).subscribe((geojson) => {
      this.previouslyLoadedBbox = bbox;

      try{
        this.dataSource.load(geojson, {
          stroke: this.color,
          fill: this.color,
          strokeWidth: 3,
          clampToGround: true,
        }).then(() => {
          this.applyStyle();
        });
      } catch (error){
        console.log(error);
      }
    });
  }

  applyStyle(): void {
    this.dataSource.entities.values.forEach((item) => {
      if (this.detailVisible) {
        switch (item.properties.niveau.getValue()) {
          case 'FORT':
            item.polygon.material = this.colorFort;
            break;
          case 'MOYEN':
            item.polygon.material = this.colorMoyen;
            break;
          default:
            item.polygon.material = this.color;
            break;
        }
      } else {
        item.polygon.material = this.color;
      }
    });
  }

  setActive(active: boolean): void  {
    this.active = active;
    this.dataSource.show = active;

    if (active) {
      this.loadData();
    }
  }

  onAfterPrint(): void {
  }

  onBeforePrint(): void {
  }
}
